import { TAction }             from "store/sellers/d";
import { SELLERS_SET_SELLERS } from "store/sellers/types";

export const _actionSetSellers = (sellers: any) : TAction => ({
    type: SELLERS_SET_SELLERS,
    payload: sellers
})
